<template>
	<div class="wrapper">
		<div class="news-list">
			<router-link
				class="list-item"
				v-for="(item, index) in newList"
				:key="index"
				:to="$route.query.tab == 1 ? '/detail/index?mode=notice&id=' + item.id : '/detail/index?mode=news&id=' + item.id"
			>  
            <!-- 公告的tab为1 -->
				<div class="text-part">
					<div class="date" :style="{display: $i18n.locale=='en' ? 'clock' : 'flex'}">
						<div class="date-title">
							{{ item.categoryName || $t('lang.Notice') }}
						</div>
						<div class="date-time" :style="{marginLeft: $i18n.locale=='en' ? '1rem' : ''}">
							{{ String(item.createTime).split(' ')[0] }}
						</div>
					</div>
					<div class="content pl-3 pr-3">
						<div class="content-title">
							{{ item.title }}
						</div>
						<div class="content-text">
							{{
								item.describe || item.remark || getSimpleText(item.content).slice(60, 260) 
							}}
						</div>
					</div>
				</div>
				<div class="img-part img-wrap img-hovor">
					<img
						width="100%"
						height="100%"
						:src="item.titleImg || item.srcFileName"
					/>
				</div>
			</router-link>
		</div>
	</div>
</template>
<script>

export default {
	props: {
		newList: {
			type: Array,
			default: () => [
				// {
				// 	type: '新闻发布会',
				// 	title:
				// 		'2020未来科学大奖举行云端颁奖典礼 | 科学之光 温暖世界',
				// 	date: '2020-12-30',
				// 	info: '科学之光 温暖世界',
				// 	src:
				// 		'http://www.futureprize.org/resource/data/uploads/99/c8389d231e05b20696be900fbb0d1b9b.jpg',
				// },
			],
		},
	},

	watch: {
		newList(val) {
			this.newList = val
		},
	},
	methods: {
		getSimpleText(html) {
			var re1 = new RegExp('<.+?>', 'g') //匹配html标签的正no则表达式，"g"是搜索匹配多个符合的内容
			var msg = html.replace(re1, '') //执行替换成空字符
			var re2 = new RegExp('&nbsp;', 'g')
			var newmsg = msg.replace(re2, '')
			return newmsg
		},
	},
}
</script>
<style lang="scss" scoped>
.wrapper::v-deep {
	.news-list {
		a {
			text-decoration: none;
		}
		.list-item {
			display: flex;
			flex-direction: row-reverse;
			align-items: center;
			padding: 2rem 0 1rem 0;
			cursor: pointer;
			text-decoration: none;
			border-bottom: 0.1rem solid #ebebeb;
			box-sizing: border-box;

			.text-part {
				display: flex;
				flex-direction: column-reverse;
				flex: 1.7;
				justify-content: space-between;
				.date {
					.date-title {
						padding-left: 1rem;
						font-size: 1rem;
						color: #333333;
						min-height: 2rem;
					}
					.date-time {
						margin-left: 2rem;
						font-size: 1rem;
						color: #999999;
					}
				}
				.content {
					.content-title {
						font-size: 1.4rem;
						color: #4a4a4a;
						overflow: hidden;
						text-overflow: ellipsis;
						height: 4rem;
					}
					.content-text {
						height: 8.5rem;
						margin-top: 1rem;
						font-size: 1rem;
						color: #666666;
						overflow: hidden;
					}
					@media (max-width: 768px) {
						.content-title{
							line-height: 2rem;
						}
						.content-text {
							margin-top: 0;
							height: 3.2rem;
						}
					}
				}
			}
			.img-part {
				flex: 0.8;
				height: 8rem;
			}
			.img-wrap {
				margin: 0;
				min-height: 8rem;
			}
		}
		.list-item:hover {
			background: #f7f7f7;
		}
	}

	@media (min-width: 992px) {
		.img-wrap {
			margin: 0;
			min-height: 12rem;
		}
		.img-part {
			flex: 0.7;
			height: 8rem;
		}
	}
	@media (min-width: 768px) {
		.news-list {
			.list-item {
				display: flex;
				flex-direction: row;
				align-items: unset;
				padding: 3.8rem 2rem;

				.text-part {
					display: flex;
					flex-direction: row;
					.date {
						display: block;
						flex: 1;
						.date-time {
							margin-left: 0rem;
							font-size: 1rem;
							color: #999999;
						}
						.date-title {
							padding: 0;
							font-size: 1.2rem;
						}
					}
					.content {
						flex: 3;
						.content-text {
							line-height: 1.7rem;
						}
					}
				}
				.img-wrap {
					margin: 0;
					min-height: 15rem;
				}
			}
		}
	}
}
</style>
